const slides = {
  addSlide: "הוסף שקופית",
  deleteSlide: "מחק שקופית",
  duplicateSlide: "שכפל שקופית",
  addText: "הוסף טקסט",
  addImage: "הוסף תמונה",
  addShape: "הוסף צורה",
  present: "הצג",
  exitPresentation: "יציאה ממצגת",
  slideOf: "שקופית {current} מתוך {total}",
  fontFamily: "גופן",
  fontSize: "גודל גופן",
  fillColor: "צבע מילוי",
  borderColor: "צבע גבול",
  bringForward: "הבא קדימה",
  sendBackward: "שלח אחורה",
  deleteElement: "מחק אלמנט",
  rectangle: "מלבן",
  circle: "עיגול",
  arrow: "חץ",
  line: "קו",
  untitled: "מצגת ללא שם",
} as const;
export default slides;
